export default __webpack_public_path__ + "static/media/Fraunces-Italic.3411c007.ttf";